<template>
	<div class="note-card">
		<h2>Match Details</h2>
		<p>Based on the information provided in the budget above, the match percentage is <strong> {{ match_percentage }} %.</strong></p>
		<p>Provide a breakdown of the Match being offered:</p>
		<el-form-item prop="match_details.applicant_amount" label="Applicant Amount" :rules="validation.applicant_amount">
			<el-input v-model="applicant_amount" v-currency="money"/>
		</el-form-item>
		<el-form-item prop="match_details.landowner_donation" label="Landowner Donation Amount" :rules="validation.landowner_donation">
			<el-input v-model="landowner_donation" v-currency="money"/>
		</el-form-item>
		<el-form-item prop="match_details.provided_grants" label="Have you received any grants for this project?" :rules="validation.provided_grants">
			<el-radio-group v-model="provided_grants">
				<el-radio :label="true">Yes</el-radio>
				<el-radio :label="false">No</el-radio>
			</el-radio-group>
		</el-form-item>
		<grants v-if="provided_grants"/>
		<el-form-item prop="match_details.are_additional_matches" label="Have any additional match?" :rules="validation.are_additional_matches">
			<el-radio-group v-model="are_additional_matches">
				<el-radio :label="true">Yes</el-radio>
				<el-radio :label="false">No</el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item v-if="are_additional_matches" prop="match_details.other" label="Describe any additional matches, the source of the match and the method used to determine the value:" :rules="validation.other">
			<el-input v-model="other" type="textarea" :autosize="input_config.textarea_autosize"/>
		</el-form-item>

		<el-form-item prop="match_details.are_in_kind_matches" label="Any In-Kind Match?" :rules="validation.are_in_kind_matches">
			<el-radio-group v-model="are_in_kind_matches">
				<el-radio :label="true">Yes</el-radio>
				<el-radio :label="false">No</el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item v-if="are_in_kind_matches" prop="match_details.in_kind_description" label="Describe any in-kind match, the source of the match and the method used to determine the value:" :rules="validation.in_kind_description">
			<el-input v-model="in_kind_description" type="textarea" :autosize="input_config.textarea_autosize"/>
		</el-form-item>

		<el-form-item prop="match_details.are_unfunded_grants" label="Did the applicant apply for other grants that were not funded?" :rules="validation.are_unfunded_grants">
			<el-radio-group v-model="are_unfunded_grants">
				<el-radio :label="true">Yes</el-radio>
				<el-radio :label="false">No</el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item v-if="are_unfunded_grants" prop="match_details.unfunded_grant_description" label="Describe any grants that were not funded:" :rules="validation.other">
			<el-input v-model="unfunded_grant_description" type="textarea" :autosize="input_config.textarea_autosize"/>
		</el-form-item>
	</div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import { mapSimpleValidation } from '@/js/utilities/validation-mapper.js';
import money_mixin from '@/js/mixins/money-mixin.js';
import grants from './Grant-Detail';
// import { unformat } from 'accounting-js';
export default {
	mixins: [ money_mixin ],
	components: {	grants },
	created(){
	},
	computed: {
		...mapGetters('application/project_budget', ['getMatchTotal', 'getGreenbeltTotal', 'match_percentage']),

		...mapFields('application/project_budget', [
			'match_details.landowner_donation',
			'match_details.provided_grants',
			'match_details.grant.amount',
			'match_details.grant.name',
			'match_details.grant.date_awarded',
			'match_details.applicant_amount',
			'match_details.are_additional_matches',
			'match_details.other',
			'match_details.are_in_kind_matches',
			'match_details.in_kind_description',
			'match_details.are_unfunded_grants',
			'match_details.unfunded_grant_description',
		])
	},
	data(){
		return {
			validation: {
				...mapSimpleValidation(['applicant_amount','landowner_donation', 'provided_grants', 'are_additional_matches', 'other', 'are_in_kind_matches', 'in_kind_description', 'are_unfunded_grants', 'unfunded_grant_description'],
			)
		}
	}
}
}
</script>
